exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".zlTOIqgXrUeoE4QgaYR88{vertical-align:middle;width:14px;height:14px;display:inline-block}", ""]);
// Exports
exports.locals = {
	"linkSpinner": "zlTOIqgXrUeoE4QgaYR88"
};